












































import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowBottom from "@/common/components/icons/IconArrowBottom.vue";
import { Prop, Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    IconBase,
    IconArrowBottom
  }
})
export default class InputSelect extends Vue {
  @Prop({ type: String, required: false }) id!: string;
  @Prop({ type: String, required: true }) name!: string;
  @Prop({ type: [String, Number], required: true }) value!: any;
  @Prop({ type: String, required: false }) error!: string;
  @Prop({ type: Array, required: true }) options!: any;
  @Prop({ type: String, default: "" }) color!: string;
  @Prop({ type: [String, Boolean], default: false }) fontFamily!: any;

  updateValue(e: any) {
    const selectedIndex = e.target.selectedIndex;
    const options = e.target.options;
    const value = options && options.length ? options[selectedIndex].value : "";
    this.$emit("input", value);
    this.$emit("selected", value);
  }
}
